import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import { useApp, useAppDispatchers } from '../../state/app';
import { useUser } from '../../state/user';
import ForgotPassword from '.';

const ForgotPasswordContainer = props => {
  const { analytics } = useContext(AnalyticsContext);
  const history = useHistory();
  const { regAccessToken, error, message, loading } = useApp();
  const { forgotPassword } = useAppDispatchers();
  const { tempPhoneNumber } = useUser();

  const childProps = {
    ...props,
    analytics,
    error,
    forgotPassword,
    message,
    loading,
    regAccessToken,
    tempPhoneNumber,
    history
  };

  return <ForgotPassword {...childProps} />;
};

export default ForgotPasswordContainer;
